import React from 'react';
import { useOfferListFilterContext } from 'src/areas/product/components/offer-list-filter-context';
import { Price } from 'src/types';
import { FilterTypeEnum } from 'src/components/price-list/types';
import { SizeVariants } from './size-variants';
import { useVariantValues } from './hooks/use-variant-values';
import {
  createNewSelection,
  addSelectionToVariantValues,
} from './size-variants/utils';

export const Variants: React.FC<IVariants> = ({ offers }) => {
  const {
    getFilter,
    setFilterSelection,
    toggleFilter,
  } = useOfferListFilterContext();
  const variantSizeFilter = getFilter(FilterTypeEnum.VARIANT_SIZE);
  const selectedSizeVariants = variantSizeFilter?.active
    ? variantSizeFilter?.selection
    : null;
  const variantsValuesInOffers = useVariantValues(offers);
  const variantValuesToShow = addSelectionToVariantValues(
    variantsValuesInOffers,
    selectedSizeVariants || []
  );

  if (!variantValuesToShow?.sizes?.length) {
    return null;
  }

  const handleSelection = (variant: string | null) => {
    const newSelection = createNewSelection(
      variant,
      selectedSizeVariants?.length ? selectedSizeVariants : []
    );
    if (variantSizeFilter?.active && newSelection.length === 0) {
      toggleFilter(FilterTypeEnum.VARIANT_SIZE);
    } else {
      setFilterSelection(FilterTypeEnum.VARIANT_SIZE, newSelection);
    }
  };

  return (
    <SizeVariants
      handleSelection={handleSelection}
      variants={variantValuesToShow}
    />
  );
};

interface IVariants {
  offers: Price[];
}
